/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCLeftIcon24Regular = forwardRef('ArrowCLeftIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M16.119 20.617a.875.875 0 0 1-1.238 0L8.474 14.21a3.125 3.125 0 0 1 0-4.42l6.407-6.406A.875.875 0 1 1 16.12 4.62l-6.407 6.407a1.375 1.375 0 0 0 0 1.944l6.407 6.407a.875.875 0 0 1 0 1.238Z" })));
});
